<template>
    <main
      class="post"
    >
    <article class="post__container" v-if="data !== undefined">
      <div class="post__animation-container">
        <div class="post__eyelet" data-anim="fade">
          <AppSubheading
            class="post__category"
            :data="{
              content: data.acf.category.name,
            }"
          />
          <router-link
            class="eyelet__link"
            to="/insights"
          >
            <AppSubheading
              :data="{
                content: '< BACK TO BLOG',
              }"
            />
          </router-link>
        </div>
        <AppHeadline
          :data="{
            content: data.title,
            type: 2,
          }"
          class="post__title"
          data-anim="fade"
        />
        <div class="post__intro" data-anim="fade">
          <AppParagraph
            class="intro__text"
            :data="{
              content: data.acf.intro,
            }"
          />
          <div class="post__time">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
              <path
                stroke="white"
                fill="none"
                d="M15 8c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zM12.9 3.1L8 8"
              />
            </svg>
            <AppSubheading
              class="time__text"
              :data="{
                content: `${data.acf['reading_time']} MIN READ`,
              }"
            />
          </div>
        </div>
        <div
          class="post__image"
          data-anim="fade"
          :style="{
            backgroundImage: `url(${data.acf.image.url})`
          }"
        />

        <div class="post__content">
          <div class="content__column">
            <component
              v-for="(section, i) in data.acf.sections"
              :key="`content-${i}`"
              :is="section.frontId"
              :data="{
                content: section[section['acf_fc_layout']],
              }"
              data-anim="fade"
            />
          </div>
          <div class="content__column" data-anim="staggerList">
            <AppSubheading
              :data="{
                content: 'MOST RECENT POST',
              }"
              v-if="lastests.length > 0"
              class="post__list-title"
            />
            <ul
              v-if="lastests.length > 0"
              class="post__list"
            >
              <li
                v-for="(lastest, i) in lastests"
                :key="`last-${i}`"
              >
                <router-link :to="`/insights${lastest.path}`">
                  <AppHeadline
                    :data="{
                      content: `${i}. ${lastest.title}`,
                      type: 3,
                    }"
                    class="post__title"
                  />
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>

    <AppSection
      class="subscribe"
      :data="{
        img: { src: '' }
      }"
    >
      <div class="subscribe__container">
        <AppHeadline
          class="subscribe__title"
          :data="{
            content: 'SUBSCRIBE',
            type: 2,
          }"
        />
        <span class="section__line subscribe__line"></span>
        <AppParagraph
          class="subscribe__text"
          :data="{
            content: 'Get latest news about fundraising, data-driven behavioral change, way ahead of anyone else',
          }"
        />
        <form
          action="#"
          class="newsletter__wrapper"
          novalidate
          ref="form"
          @submit.prevent="send"
        >
          <div class="input__email">
            <div data-animation="fade" data-delay="0.2">
              <input
                type="email"
                name="email"
                ref="email"
                id="email"
                placeholder="YOUR NAME"
                required
              >
              <div class="newsletter__thx" v-show="state === 'sent'" style="transform: scaleY(0)">
                <p style="opacity: 0;">
                  Thanks for your subscription
                </p>
              </div>
            </div>
          </div>

          <div class="input__submit" data-animation="fade" data-delay="0.8" ref="submit">
            <appSubheading
              class="input__submit-text"
              :data="{ content: 'SUBSCRIBE' }"
            />
            <input
              type="submit"
              value=""
            >
          </div>
        </form>

        <AppParagraph
          class="subscribe__advice"
          :data="{
            content: 'We keep your data safe and send you not more than 1-2 useful emails a month. *',
          }"
        />
      </div>
      <AppFooter class="footer" :short="true" />
    </AppSection>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  TweenMax,
  TimelineMax,
  Power4,
  Expo,
} from 'gsap/TweenMax';
import { animations, initial } from '@/scripts/fx';

import raf from '@/scripts/raf';
import api from '@/scripts/api';
import mail from '@/scripts/mail';

import AppSection from '@/components/AppSection.vue';
import AppHeadline from '@/components/AppHeadline.vue';
import AppSubheading from '@/components/AppSubheading.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppQuote from '@/components/AppQuote.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'Post',
  components: {
    AppSection,
    AppHeadline,
    AppSubheading,
    AppParagraph,
    AppQuote,
    AppFooter,
  },
  computed: {
    ...mapGetters({ news: 'getNews', post: 'getCurrrentPost' }),
  },
  data() {
    return {
      data: undefined,
      animationsAdded: false,
      lastests: [],
      state: false,
      footerAnimationAdded: false,
      loopIsRunning: false,
    };
  },
  created() {
    if (this.post === undefined) {
      api.fetchPage(this.$route.params.post, 'post')
        .then((res) => {
          this.data = res.page;
          this.animationsAdded = true;
          setTimeout(() => {
            if (!this.loopIsRunning) {
              this.loopIsRunning = true;
              this.initializeAnimations(this.$el);
            }
          }, 500);

          this.getFooterPost();
        });
    } else {
      this.data = this.post;
      this.animationsAdded = true;
      this.lastests = this.news.firstItems.slice(0, 3);
      this.footerAnimationAdded = true;
      raf.add(() => this.footer(), 'footer-animation-post');
    }
  },
  mounted() {
    TweenMax.set('.subscribe__title', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe__line', { scaleY: 0, transformOrigin: '50% 0%' });
    TweenMax.set('.subscribe__text', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe form', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe__advice', { autoAlpha: 0, y: 50 });
    TweenMax.set('.subscribe .footer', { autoAlpha: 0, y: 50 });
    if (!this.loopIsRunning && this.data !== undefined) {
      this.loopIsRunning = true;
      this.initializeAnimations(this.$el);
    }
  },
  methods: {
    getFooterPost() {
      const callback = () => {
        this.lastests = this.news.firstItems.slice(0, 3);
        this.footerAnimationAdded = true;
        raf.add(() => this.footer(), 'animation-preview');
      };

      if (this.news.firstItems.length === 0) {
        this.$store.dispatch('FETCH_NEWS').then(() => callback());
      } else {
        callback();
      }
    },
    initializeAnimations(ctx) {
      const label = `animations-${this.$route.params.post}`;
      const els = Array.from(ctx.querySelectorAll('[data-anim]'));
      TweenMax.set('.post__animation-container', { autoAlpha: 1 });

      if (els.length > 0) {
        const elsToSet = [];

        els.forEach((el) => {
          const obj = this.createObjToAnimate(el);
          elsToSet.push(obj);

          initial.get(obj.animation)(obj);
        });

        const handlerAnimations = () => this.addAnimationsPage(elsToSet, label);
        raf.add(handlerAnimations, label, true);

        if (raf.stopped) raf.start();
        this.loopIsRunning = true;
      }
    },
    createObjToAnimate(el) {
      const obj = {
        node: el,
        initFromTop: el.getBoundingClientRect().top,
        fromTop() {
          return this.node.getBoundingClientRect().top;
        },
        height: el.getBoundingClientRect().height,
        animation: el.getAttribute('data-anim'),
        isAnimated: false,
        isVisible: false,
        splitted: false,
      };

      return obj;
    },
    addAnimationsPage(els, label) {
      els.forEach((el, i) => {
        if (!el.isAnimated && el.fromTop() < (window.innerHeight / 1.8)) {
          el.isAnimated = true; // eslint-disable-line
          el.isVisible = true; // eslint-disable-line

          animations.get(el.animation)(el);
        } else if (el.isVisible
          && ((el.fromTop() + el.height) < 0 || el.fromTop() > window.innerHeight)) {
          el.isVisible = false; // eslint-disable-line

          if (els.length === 1) {
            raf.remove(label);
            this.loopIsRunning = false;
          }

          if (el.splitted) el.instance.revert();
          els.splice(i, 1);
        }
      });
    },
    send() {
      const valid = this.validate();

      if (valid) {
        this.$el.style.pointerEvents = 'none';

        const tl = new TimelineMax({
          paused: true,
          onComplete: () => {
            this.state = 'sent';
            this.$el.style.pointerEvents = 'auto';

            console.log(this.$el.querySelector('.newsletter__thx'));

            TweenMax.to('.newsletter__thx', 1, {
              scaleY: 1,
              transformOrigin: '50% 100%',
              ease: Expo.easeOut,
            });

            TweenMax.to('.newsletter__thx p', 0.7, {
              autoAlpha: 1,
              delay: 1,
              ease: Expo.easeOut,
            });
          },
        });

        tl
          .addLabel('start')
          .to(
            [
              this.$refs.email,
              this.$refs.submit,
            ], 0.7, {
              autoAlpha: 0,
              ease: Expo.easeOut,
            }, 'start+=1',
          );

        const formData = new FormData(this.$refs.form);
        const config = {
          u: '735bf74e451de894cb58a6c71',
          id: '7bec07109a',
          url: 'moonshot.us4',
        };
        const user = {
          email: formData.get('email'),
        };

        mail(config, user).then(response => response.json()
          .then((json) => {
            if (json.result === 'success') {
              tl.play();
              window.fbq('track', 'CompleteRegistration', {
                content_name: 'Subscription to newsletter from landing page',
                value: user.email,
              });
            }
          }).catch((ex) => {
            this.$el.style.pointerEvents = 'auto';
            console.log('ex: ', ex);
          }));
      }
    },
    validate() {
      let valid = false;

      if (!this.regexEmail(this.$refs.email.value)) {
        this.error('email');
      }

      if (this.regexEmail(this.$refs.email.value)) {
        valid = true;
      }

      return valid;
    },
    regexEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    },
    error(input) {
      if (input === 'email') {
        TweenMax.to(this.$refs.line, 0.5, {
          backgroundColor: '#ff1744',
          ease: Expo.easeOut,
          yoyo: true,
          repeat: 1,
        });
      }

      if (input === 'privacy') {
        TweenMax.to(this.$refs.fakeInput, 0.5, {
          borderColor: '#ff1744',
          ease: Expo.easeOut,
          yoyo: true,
          repeat: 1,
        });
      }
    },
    footer() {
      if (this.$el.querySelector('.subscribe').getBoundingClientRect().top < (window.innerHeight / 2)
        && this.footerAnimationAdded) {
        this.footerAnimationAdded = false;
        raf.remove('footer-animation-post');

        const tl = new TimelineMax();
        tl.addLabel('start')
          .to('.subscribe__title', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start')
          .to('.subscribe__line', 1, {
            scaleY: 1,
            ease: Power4.easeOut,
          }, 'start+=0.25')
          .to('.subscribe__text', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=0.5')
          .to('.subscribe form', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=0.75')
          .to('.subscribe__advice', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=1')
          .to('.subscribe .footer', 1, {
            autoAlpha: 1,
            y: 0,
            ease: Power4.easeOut,
          }, 'start+=1.25');
      }
    },
  },
  beforeDestroy() {
    if (this.footerAnimationAdded) raf.remove('footer-animation-post');
    if (this.loopIsRunning) raf.remove(`add-animation-${this.$route.params.post}`);
  },
};
</script>

<style lang="scss" scoped>
.post {
  &__animation-container {
    opacity: 0;
  }

  &__container {
    padding: 80px 20px 80px;
    min-height: 150vh;

    @include mq(ipadP) {
      padding: 120px 40px 40px;
    }

    @include mq(ds) {
      padding: 120px 80px 80px;
    }

    @include mq(ds) {
      padding: 120px 120px 120px;
    }

    background-image: linear-gradient(180deg, #9EA0AC 0%, #141B37 100%);
  }

  &__eyelet {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .post__category {
      display: inline-block;
    }

    .eyelet__link {
      display: inline-block;

      @include mq($and: $is-not-touch-device) {
        &::before {
          content: '';

          position: absolute;
          bottom: -5px;
          left: 0px;
          width: 100%;
          height: 1px;

          background-color: $color-white;
          transform-origin: 100% 50%;
          transform: scaleX(0);
          transition: transform 1s $outQuint;
        }

        &:hover {
          opacity: 1;

          &::before {
            transform-origin: 0 50%;
            transform: scaleX(1);
            background-color: rgba($color-white, 1);
          }
        }
      }
    }
  }

  &__title {
    margin: 25px 0 40px;
    text-align: left;
  }

  &__intro {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    margin-bottom: 40px;

    .intro__text::v-deep p p {
      margin: 0;
    }

    .intro__text {
      flex: 0 0 50vw;
    }
  }

  &__time {
    margin-bottom: 7px;

    svg {
      display: inline-block;
      width: 15px;
    }

    .time__text {
      display: inline-block;
      margin-left: 10px;
    }
  }

  &__image {
    position: relative;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    @include aspect-ratio(5, 3);
  }

  &__content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    @include mq($until: ipadP) {
      flex-flow: column nowrap;
    }

    .content__column:first-child {
      @include mq(ipadP) {
        max-width: 50vw;
      }
    }

    .content__column:last-child {
      width: 100%;

      @include mq(ipadP) {
        width: 25vw;
      }
    }

    .post__list-title {
      margin-top: 60px;
    }

    .post__list {
      width: 100%;

      li {
        display: block;
        border-bottom: 1px solid $color-white;

        &::v-deep h3 {
          font-size: 20px;
        }
      }
    }
  }

  .subscribe,
  .subscribe__container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  .subscribe {
    background-image: linear-gradient(134deg, #261E3C 0%, #9F7B8A 100%);

    &__text {
      max-width: 400px;
    }

    .newsletter__thx {
      width: 400px;
    }

    &__container {
      text-align: center;

      form {
        width: 100%;
        max-width: 400px;
        margin: 50px 0;

        display: flex;
        align-items: center;
        justify-content: space-between;

        .input__email {
          flex: 1 1 auto;
          margin-right: 5px;

          input {
            width: 100%;
            padding: 10px 15px;

            color: $color-white;
            border: 1px solid $color-white;
            background-color: transparent;

            &:focus {
              outline: transparent;
            }
          }
        }

        .input__submit {
          position: relative;
          background-color: $color-white;
          padding: 10px 15px;

          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            background-color: transparent;
            border: none;
            cursor: pointer;

            &:focus {
              outline: transparent;
            }

            &::placeholder {
              color: transparent;
            }
          }

          &-text::v-deep h5 {
            color: black;
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    background-image: unset;
  }
}
</style>
